import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import UnsereKompetenzfelder from "./sections/UnsereKompetenzfelder";
import IhreIdeeAlsNaechstesProjekt from "./sections/IhreIdeeAlsNaechstesProjekt";
import TechnologyProducts from "./sections/TechnologyProducts";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <UnsereKompetenzfelder />
      <IhreIdeeAlsNaechstesProjekt />
      <TechnologyProducts />
      <Footer />
    </div>;
}